
export class AmplifyDialogComponentTextModel {
    buttonUseSelected: string = 'Core.button.useSelected';
    buttonCancel: string = 'Core.button.cancel';
    buttonDisabledTooltip: string = '';
    headerText: string = 'Amplify';
    releaseStory: string = 'Release a Story to the';
    releaseWire: string = 'Send a Press Release via';
    newsroom: string = 'NEWSROOM';
    newswire: string = 'NEWSWIRE';
    newStory: string =  'NEW STORY';
    newPressRelease: string = 'NEW PRESS RELEASE' ;
    or: string = 'OR';
    existingContent: string = 'CHOOSE EXISTING CONTENT TO AMPLIFY';
}
